import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { HourglassTop as HourglassIcon } from '@mui/icons-material';

const PendingApprovalBanner = () => {
  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <Alert
        severity="info"
        icon={<HourglassIcon />}
        sx={{ borderRadius: 2 }}
      >
        <AlertTitle>Access Request Pending</AlertTitle>
        Your access request is being reviewed by a manager. You will receive an email once approved.
        Until then, some features may not be available.
      </Alert>
    </Box>
  );
};

export default PendingApprovalBanner;
